import { ref } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";
import handleError from "@utils/composables/handleError";

export const useLocalesStore = defineStore("mLocales", () => {
  const locales = ref([]);

  const fetchLocales = async () => {
    try {
      const url = `/facebook/locales`;
      const { response, data } = await useMyFetch(url).json();
      if (response.value.ok) locales.value = data.value.data;
    } catch (err) {
      handleError(err);
      return [];
    }
  };

  return {
    locales,
    fetchLocales,
  };
});
